import { render, staticRenderFns } from "./CockpitRespostaFormulario.vue?vue&type=template&id=0a9e03b0&scoped=true"
import script from "./CockpitRespostaFormulario.vue?vue&type=script&lang=js"
export * from "./CockpitRespostaFormulario.vue?vue&type=script&lang=js"
import style0 from "./CockpitRespostaFormulario.vue?vue&type=style&index=0&id=0a9e03b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e03b0",
  null
  
)

export default component.exports